import NotFoundPage from '../pages/404';
import { LoginPage } from '../pages/auth/login';
import { RecoverPass } from '../pages/auth/recover';
import { ResetPasswordPage } from '../pages/auth/resetPassword';

export const OpenRoutes = [
  {
    name: 'Not Found',
    path: '*',
    component: NotFoundPage,
  },
  {
    name: 'Login',
    path: '/login',
    component: LoginPage,
  },
  {
    name: 'Recuperar Senha',
    path: '/recover',
    component: RecoverPass,
  },
  {
    name: 'Criar Nova Senha',
    path: '/reset-password',
    component: ResetPasswordPage,
  },
];
